import {
  LIST_MASTER_DATA_PROFILE_REQUEST,
  LIST_MASTER_DATA_PROFILE_SUCCESS,
  LIST_MASTER_DATA_PROFILE_FAIL,
  LIST_PROFILE_CONFIG_REQUEST,
  LIST_PROFILE_CONFIG_SUCCESS,
  LIST_PROFILE_CONFIG_FAIL,
  LIST_LAST_PROJECT_SYNC_REQUEST,
  LIST_LAST_PROJECT_SYNC_SUCCESS,
  LIST_LAST_PROJECT_SYNC_FAIL,
  RE_SYNC_DATA_REQUEST,
  RE_SYNC_DATA_SUCCESS,
  RE_SYNC_DATA_FAIL,
  CREATE_SYNC_PROFILE_CONFIG_REQUEST,
  CREATE_SYNC_PROFILE_CONFIG_SUCCESS,
  CREATE_SYNC_PROFILE_CONFIG_FAIL,
  CREATE_SYNC_PROFILE_CONFIG_BY_ID_REQUEST,
  CREATE_SYNC_PROFILE_CONFIG_BY_ID_SUCCESS,
  CREATE_SYNC_PROFILE_CONFIG_BY_ID_FAIL,
  CREATE_SYNC_PROJECT_DATA_REQUEST,
  CREATE_SYNC_PROJECT_DATA_SUCCESS,
  CREATE_SYNC_PROJECT_DATA_FAIL,
  CREATE_SYNC_BRANCH_SERVICE_REQUEST,
  CREATE_SYNC_BRANCH_SERVICE_SUCCESS,
  CREATE_SYNC_BRANCH_SERVICE_FAIL,
  CREATE_SYNC_BRANCH_PACKAGE_REQUEST,
  CREATE_SYNC_BRANCH_PACKAGE_SUCCESS,
  CREATE_SYNC_BRANCH_PACKAGE_FAIL,
  LIST_SYNC_PROJECT_LOG_REQUEST,
  LIST_SYNC_PROJECT_LOG_SUCCESS,
  LIST_SYNC_PROJECT_LOG_FAIL
} from '../../../constants/synchronize-data/master-data'

const initialState = {
  loadingReSync: false,
  loadingProfileConfig: false,
  loadingMasterDataConfig: false,
  loadingSyncCreateSyncConfig: false,
  loadingLastProfileConfigSync: false,
  loadingSyncSyncConfigById: false,
  loadingSyncProjectDataById: false,
  loadingSyncBranchService: false,
  loadingSyncLog: false,
  syncLogList: [],
  masterDataConfig: [],
  profileConfig: [],
  lastProfileConfigSync: [],
  error: null,
  pageableProfile: {
    page: 1,
    size: 10
  },
  pageable: {
    page: 1,
    size: 10
  }
}

const masterDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_MASTER_DATA_PROFILE_REQUEST:
      return { ...state, loadingMasterDataConfig: true, error: false }
    case LIST_MASTER_DATA_PROFILE_SUCCESS:
      return {
        ...state,
        loadingMasterDataConfig: false,
        masterDataConfig: action.payload,
        pageable: action.pageable
      }
    case LIST_MASTER_DATA_PROFILE_FAIL:
      return {
        ...state,
        loadingMasterDataConfig: false,
        error: action.payload
      }
    case LIST_SYNC_PROJECT_LOG_REQUEST:
      return { ...state, loadingSyncLog: true, error: false }
    case LIST_SYNC_PROJECT_LOG_SUCCESS:
      return {
        ...state,
        loadingSyncLog: false,
        syncLogList: action.payload,
        pageable: action.pageable
      }
    case LIST_SYNC_PROJECT_LOG_FAIL:
      return {
        ...state,
        loadingSyncLog: false,
        error: action.payload
      }
    case LIST_PROFILE_CONFIG_REQUEST:
      return { ...state, loadingProfileConfig: true, error: false }
    case LIST_PROFILE_CONFIG_SUCCESS:
      return {
        ...state,
        loadingProfileConfig: false,
        profileConfig: action.payload,
        pageableProfile: action.pageable
      }
    case LIST_PROFILE_CONFIG_FAIL:
      return {
        ...state,
        loadingProfileConfig: false,
        error: action.payload
      }
    case LIST_LAST_PROJECT_SYNC_REQUEST:
      return { ...state, loadingLastProfileConfigSync: true, error: false }
    case LIST_LAST_PROJECT_SYNC_SUCCESS:
      return {
        ...state,
        loadingLastProfileConfigSync: false,
        lastProfileConfigSync: action.payload
      }
    case LIST_LAST_PROJECT_SYNC_FAIL:
      return {
        ...state,
        loadingLastProfileConfigSync: false,
        error: action.payload
      }
    case RE_SYNC_DATA_REQUEST:
      return { ...state, loadingReSync: true }
    case RE_SYNC_DATA_SUCCESS:
      return {
        ...state,
        loadingReSync: false
      }
    case RE_SYNC_DATA_FAIL:
      return {
        ...state,
        loadingReSync: false,
        error: action.payload
      }
    case CREATE_SYNC_PROFILE_CONFIG_REQUEST:
      return { ...state, loadingSyncCreateSyncConfig: true, error: false }
    case CREATE_SYNC_PROFILE_CONFIG_SUCCESS:
      return {
        ...state,
        loadingSyncCreateSyncConfig: false
      }
    case CREATE_SYNC_PROFILE_CONFIG_FAIL:
      return {
        ...state,
        loadingSyncCreateSyncConfig: false,
        error: action.payload
      }

    case CREATE_SYNC_PROFILE_CONFIG_BY_ID_REQUEST:
      return { ...state, loadingSyncSyncConfigById: true, error: false }
    case CREATE_SYNC_PROFILE_CONFIG_BY_ID_SUCCESS:
      return {
        ...state,
        loadingSyncSyncConfigById: false
      }
    case CREATE_SYNC_PROFILE_CONFIG_BY_ID_FAIL:
      return {
        ...state,
        loadingSyncSyncConfigById: false,
        error: action.payload
      }

    case CREATE_SYNC_PROJECT_DATA_REQUEST:
      return { ...state, loadingSyncProjectDataById: true, error: false }
    case CREATE_SYNC_PROJECT_DATA_SUCCESS:
      return {
        ...state,
        loadingSyncProjectDataById: false
      }
    case CREATE_SYNC_PROJECT_DATA_FAIL:
      return {
        ...state,
        loadingSyncProjectDataById: false,
        error: action.payload
      }

    case CREATE_SYNC_PROJECT_DATA_REQUEST:
      return { ...state, loadingSyncProjectDataById: true, error: false }
    case CREATE_SYNC_PROJECT_DATA_SUCCESS:
      return {
        ...state,
        loadingSyncProjectDataById: false
      }
    case CREATE_SYNC_PROJECT_DATA_FAIL:
      return {
        ...state,
        loadingSyncProjectDataById: false,
        error: action.payload
      }

    case CREATE_SYNC_BRANCH_SERVICE_REQUEST:
      return { ...state, loadingSyncBranchService: true, error: false }
    case CREATE_SYNC_BRANCH_SERVICE_SUCCESS:
      return {
        ...state,
        loadingSyncBranchService: false
      }
    case CREATE_SYNC_BRANCH_SERVICE_FAIL:
      return {
        ...state,
        loadingSyncBranchService: false,
        error: action.payload
      }
    case CREATE_SYNC_BRANCH_PACKAGE_REQUEST:
      return { ...state, loadingSyncBranchPackage: true, error: false }
    case CREATE_SYNC_BRANCH_PACKAGE_SUCCESS:
      return {
        ...state,
        loadingSyncBranchPackage: false
      }
    case CREATE_SYNC_BRANCH_PACKAGE_FAIL:
      return {
        ...state,
        loadingSyncBranchPackage: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default masterDataReducer
